import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { IonContent, IonAlert, IonPage, IonTitle, IonSelect, IonSelectOption, IonItem, IonLabel } from "@ionic/react";
import { Badge, Grid, Tabs, Dropdown, Spin, Row, Col, Input, Form, Button, Alert, Space } from "antd";
import { DownOutlined, ArrowLeftOutlined } from "@ant-design/icons";

/* Global State*/
import useGeneralStore from "../states/useGeneral";
import useAuthStore from "../states/useAuth";

import c from "../utils/common";
import axios from "axios";
import metaData from "../data/metaData";
import log from "../utils/log";

import { Plugins } from "@capacitor/core";
import "@ionic-native/core";
import { useTranslation } from "react-i18next";
import { showErrMsg } from "../utils/error";

const { useBreakpoint } = Grid;
const speakeasy = require("speakeasy");

const Login = () => {
  const history = useHistory();
  let currentPath = window.location.pathname;

  // const { language, changeLanguage } = useGeneralStore();
  const { user, auth, updateAuth, updateUser, updateIsResetTwoFa } = useAuthStore();

  //login form
  const [emailLoginForm] = Form.useForm();

  //TOTP form
  const [totpForm] = Form.useForm();
  const [tempJwt, setTempJwt] = useState();

  const [showTotpWrongMsg, setShowTotpWrongMsg] = useState(false);

  const [step, setStep] = useState(0);
  const [showLoginErrorMsg, setShowLoginErrorMsg1] = useState(false);
  const [showLoginErrorMsg2, setShowLoginErrorMsg2] = useState(false);

  const [showLoader1, setShowLoader1] = useState(false);

  const screens = useBreakpoint();

  const { t, i18n } = useTranslation();

  const key = "updatable";

  const roleItems = [
    {
      key: "merchantUser",
      label: "Merchant User",
    },
    {
      key: "approver",
      label: "Approver",
    },
  ];

  const contentLayout =
    screens.lg == true
      ? { padding: "3% 30% 0% 20%", width: "100%", height: "100%" }
      : screens.md == true
      ? { padding: "3% 20% 0% 10%", width: "100%", height: "100%" }
      : { width: "100%", height: "100%" };

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const tailFormItemLayout = {
    wrapperCol: {
      span: 24,
      offset: 0,
    },
  };

  function onFinishLoginForm() {
    login();
  }

  function onFinishLoginFormFailed(errorInfo) {
    //log.debug('Failed:', errorInfo)
  }

  const onFinishTotpForm = async () => {
    let isValid = await validateTotp();
    log.debug(isValid);

    if (isValid == true) {
      redirect(user, tempJwt);
      cleanUp();
    } else {
      setShowTotpWrongMsg(true);
    }
  };

  function onFinishTotpFormFailed(errorInfo) {
    //log.debug('Failed:', errorInfo)
  }

  async function login() {
    setShowLoader1(true);
    let { email, password } = emailLoginForm.getFieldsValue();
    log.debug({ email, password });

    try {
      let res = await axios.post(metaData.serverURL + "login/portal", {
        email,
        password,
      });
      log.debug(res.data);
      // Handle correct credential
      onCredentialOk(res.data);
    } catch (error) {
      let message = error.response ? error.response.data : error.message;
      if (message == "No permission to use portal") {
        return setShowLoginErrorMsg2(true);
      }

      showErrMsg(error);
    } finally {
      setShowLoader1(false);
    }
  }

  const onCredentialOk = async ({ user, token }) => {
    // log.debug({ user, token });

    updateUser("whole", user);
    setTempJwt(token);

    // Check for TOTP secret
    if (!user.secret) {
      // No secret found, redirect to reset 2FA
      // so user can login portal again
      updateIsResetTwoFa(true);
      updateAuth({ passed: true, jwt: token, role: user.role });
      history.push({ pathname: "/twoFa" });
      return;
    }

    if (metaData.twofaEnabled) {
      // Show TOTP form
      log.debug("show TOTP form");
      setShowTotpWrongMsg(false);
      totpForm.resetFields();
      setStep(1);
    } else {
      log.debug("clean up");
      redirect(user);
      cleanUp();
    }
  };

  const validateTotp = async () => {
    let { totp } = totpForm.getFieldsValue();

    let isValid = speakeasy.totp.verify({
      secret: user.secret,
      encoding: "ascii",
      token: totp,
    });
    return isValid;
  };

  const redirect = async ({ newUserSetting, role }) => {
    updateAuth({ passed: true, jwt: tempJwt, role });
    console.log("Updated Auth State:", useAuthStore.getState().auth);

    if (role == "approver") {
      history.push("/approver/shop/request");
    } else if (role == "merchantUser") {
      if (newUserSetting.getStarted) {
        history.push("/merchantUser/home");
      } else {
        history.push("/get-started");
      }
    }
  };

  const cleanUp = async () => {
    await c.sleep(500);

    emailLoginForm.resetFields();
    totpForm.resetFields();
    setStep(0);
  };

  useEffect(() => {
    if (["/login", "/"].includes(currentPath)) {
      //log.debug(currentPath + '...')
      //initIntPhone();
    }
  }, [window.location.pathname]);

  return (
    <IonPage>
      <IonAlert
        isOpen={showLoginErrorMsg}
        onDidDismiss={() => setShowLoginErrorMsg1(false)}
        cssClass=""
        message={t("login.Wrong-index-1")}
        buttons={[
          {
            text: t("login.re-enter"),
            handler: () => {
              setShowLoginErrorMsg1(false);
            },
          },
        ]}
      />

      <IonAlert
        isOpen={showLoginErrorMsg2}
        onDidDismiss={() => setShowLoginErrorMsg2(false)}
        cssClass=""
        message={t("login.NA1")}
        buttons={[
          {
            text: "OK",
            handler: () => {
              setShowLoginErrorMsg2(false);
            },
          },
        ]}
      />

      <IonContent>
        <Row align="middle" justify="center" style={contentLayout}>
          {/* {screens ? JSON.stringify(screens) : '--'} */}

          <Row style={{ padding: "5%", width: "100%" }}>
            {step == 0 ? (
              <>
                <Form.Item {...tailFormItemLayout} style={{ width: "100%" }}>
                  <Row justify="space-between" align="middle">
                    <Row align="middle">
                      <img
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "5px",
                        }}
                        src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
                      ></img>
                      <strong style={{ fontSize: "1.5rem", marginLeft: "5px" }}>
                        {t("login.description_1")}
                        <span
                          style={{
                            marginLeft: 10,
                            color: "gray",
                            fontSize: "14px",
                          }}
                        >
                          {metaData.appVersion}&nbsp;
                          {metaData.environment == "dev" ? <Badge count={"dev"} /> : null}
                        </span>
                      </strong>
                    </Row>

                    {/* <IonSelect
                      slot="end"
                      style={{
                        border: "2px double #D2C6C5",
                        borderRadius: "25px",
                      }}
                      value={language}
                      onIonChange={(e) => {
                        changeLanguage(e.detail.value);
                      }}
                    >
                      <IonSelectOption value="chn">中文</IonSelectOption>
                      <IonSelectOption value="en">English</IonSelectOption>
                    </IonSelect> */}
                  </Row>
                </Form.Item>

                <Form
                  {...formItemLayout}
                  form={emailLoginForm}
                  style={{ width: "45vw" }}
                  onFinish={onFinishLoginForm}
                  onFinishFailed={onFinishLoginFormFailed}
                >
                  <Form.Item
                    name="email"
                    label={t("register.emailPIC")}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        type: "email",
                        message: t("register.enterEmail"),
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label={t("login.Password")}
                    rules={[
                      {
                        required: true,
                        min: 9,
                        max: 16,
                        message: t("login.Pw_requirement"),
                      },
                    ]}
                  >
                    <Input.Password maxLength={16} />
                  </Form.Item>

                  {showLoader1 == true ? (
                    <Row justify="center">
                      <Spin />
                    </Row>
                  ) : (
                    <div>
                      <Form.Item {...tailFormItemLayout}>
                        <Button block type="primary" htmlType="submit">
                          {t("login.Login")}
                        </Button>
                      </Form.Item>
                      <Row gutter={16} justify="end">
                        {/* <Col span={12}>
                          <Button
                            block
                            style={{
                              backgroundColor: "var(--ion-color-step-50)",
                            }}
                            onClick={() => {
                              cleanUp();
                              history.push("/signUp");
                            }}
                          >
                            {t("login.Register")}
                          </Button>
                        </Col> */}
                        <Col span={24}>
                          <Button
                            block
                            style={{
                              backgroundColor: "var(--ion-color-step-50)",
                            }}
                            onClick={() => {
                              cleanUp();
                              history.push("/forgotPassword");
                            }}
                          >
                            {t("login.Forgot")}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Form>
              </>
            ) : null}

            {step == 1 ? (
              <Form
                {...formItemLayout}
                form={totpForm}
                onFinish={onFinishTotpForm}
                onFinishFailed={onFinishTotpFormFailed}
                style={{ width: "100%" }}
                //validateTrigger="onFinish"
              >
                <Form.Item
                  onClick={() => {
                    setStep(0);
                  }}
                >
                  <a>
                    <ArrowLeftOutlined /> {t("login.back")}
                  </a>
                </Form.Item>

                <img
                  style={{ maxWidth: "50%", height: "auto" }}
                  src={metaData.blobPreURL + "google-authenticator-logo.png" + metaData.blobPostURL}
                ></img>

                {showTotpWrongMsg == true ? (
                  <Row style={{ marginBottom: "2vw" }}>
                    <Col offset={4} span={20}>
                      <Alert
                        message={t("login.PinWrong")}
                        type="error"
                        closable
                        afterClose={() => {
                          setShowTotpWrongMsg(false);
                        }}
                      />
                    </Col>
                  </Row>
                ) : null}

                <Form.Item
                  name="totp"
                  label={t("login.V-Code")}
                  rules={[
                    {
                      required: true,
                      min: 6,
                      max: 6,
                      message: t("login.6digit"),
                    },
                    {
                      pattern: /^\d+$/,
                      message: t("login.Only6"),
                    },
                  ]}
                >
                  <Input autoFocus size="large" maxLength={6} />
                </Form.Item>

                <Form.Item {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit">
                    {t("login.confirm")}
                  </Button>
                </Form.Item>
              </Form>
            ) : null}
          </Row>
        </Row>

        {/* </Spin> */}
      </IonContent>
    </IonPage>
  );
};

export default Login;
